import { mapGetters } from 'vuex'

/**
 * Mixin for the parent components who would implement the EmbeddedMethod component
 *
 * This mixin mainly manages the height update of the parent element
 */

export const EmbeddedMethodContainerMixin = {
  data() {
    return {
      baseButtonHeight: 0
    }
  },
  computed: {
    ...mapGetters(['isEmbeddedMethod'])
  },
  mounted() {
    if (this.$el.getBoundingClientRect)
      this.baseButtonHeight = this.$el.getBoundingClientRect().height
  },
  methods: {
    updateHeight(height) {
      this.$el.style.height = this.baseButtonHeight + height + 'px'
    }
  }
}
